<template>
  <div class="px-2 py-5 text-gray-900 sm:p-6">
    <div class="flex justify-between items-center mb-4">
      <h2 class="font-bold text-md sm:text-2xl dark:text-gray-100">Notifications</h2>
      <div class="items-center sm:flex">
        <div class="hidden text-gray-500 dark:text-gray-300 sm:block">You have {{ unreadCount }} unread notifications</div>
        <button
          @click="markAllAsRead"
          :disabled="unreadCount === 0"
          v-if="unreadCount > 0"
          class="px-2 py-1 ml-2 text-xs font-semibold text-gray-900 bg-gray-100 rounded-md hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600"
        >
          Mark all as read
        </button>
      </div>
    </div>
    <DataTable
      v-if="notifications.length > 0"
      :items="notifications"
      :columns="columns"
      :pagination="pagination"
      :route-name="ROUTES.NOTIFICATION"
      @routeChange="handleRouteChange"
      @pageChange="handlePageChange"
    >
      <template #message="{ item }">
        <div>
          <p class="text-sm font-medium text-gray-900 dark:text-gray-100">{{ item.data.message }}</p>
          <p class="text-sm text-gray-500 dark:text-gray-400">Total: {{ nairaSymbol }}{{ item.data.total_amount }}</p>
        </div>
      </template>

      <template #status="{ item }">
        <span
          class="inline-flex px-2 text-xs font-semibold leading-5 text-gray-900 rounded-full"
          :class="item.read_at ? 'bg-gray-100 dark:bg-gray-300 text-gray-800' : 'bg-green-400 dark:bg-green-100 text-green-800'"
        >
          {{ item.read_at ? 'Read' : 'New' }}
        </span>
      </template>

      <template #date="{ item }">
        {{ formatDate(item.created_at) }}
      </template>

      <template #actions="{ item }">
        <RouterLink
          :to="{ name: ROUTES.NOTIFICATION, params: { id: item.id } }"
          @click="handleRouteChange(item.uuid)"
          class="p-3 w-full rounded-lg transition-colors duration-200"
          :class="{
            'bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-600': !item.read_at,
            'hover:bg-gray-100 dark:hover:bg-gray-600': true,
          }"
        >
          View
        </RouterLink>
      </template>
    </DataTable>
    <div v-else class="text-center text-gray-500">No notifications found.</div>
  </div>
</template>

<script setup>
import DataTable from '@/components/general/DataTable.vue'
import { format } from 'date-fns'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useNotificationStore } from '@/stores/notificationStore'
import { storeToRefs } from 'pinia'
import { useToast } from 'primevue/usetoast';
import { nairaSymbol } from '@/constants';
import { ROUTES } from '@/router/routeNames';
import { useNotifications } from '@/composables/useNotifications';
const toast = useToast();
const router = useRouter()
const notificationStore = useNotificationStore()
const { notifications, pagination, unreadCount } = storeToRefs(notificationStore)
const columns = [
  { key: 'id', label: 'Notification ID', format: (item) => `#${item.id}` },
  { key: 'message', label: 'Message' },
  { key: 'status', label: 'Status' },
  { key: 'date', label: 'Date' },
  { key: 'actions', label: 'Actions' },
]

const { fetchNotifications, markAllAsRead: markAllNotificationsAsRead } = notificationStore;
const {fetchNotifications: fetchComposableNotifications} = useNotifications()

onMounted(() => {
  fetchNotifications()
})

const handlePageChange = (page) => {
  fetchNotifications(page)
}

const handleRouteChange = (id) => {
  router.push({ name: ROUTES.NOTIFICATION, params: { id } })
}

const markAllAsRead = async () => {

  await markAllNotificationsAsRead()
  await fetchComposableNotifications()

  toast.add({
    severity: 'success',
    summary: 'Success',
    detail: 'All notifications marked as read',
    life: 3000
  })
}

const formatDate = (date) => {
  return format(new Date(date), 'MMM d, yyyy h:mm a');
}
</script>
